'use strict';

if (typeof subscriptionId !== 'undefined') {
    $.get(apiBaseUrl + 'plan/get/?sub_id=' + subscriptionId, function (response) {
        $(document).ready(function () {
            $('.iwr-input-license-key').val(response.license_key);
            document.body.classList.add('license-key-present');
        });
    });
}

if (typeof licenseKey !== 'undefined' && licenseKey) {
    var $licenseKeyPlaceholders = document.querySelectorAll('.iwr-input-license-key');

    if ($licenseKeyPlaceholders) {
        $licenseKeyPlaceholders.forEach(function ($licenseKeyPlaceholder) {
            $licenseKeyPlaceholder.value = licenseKey;
        });
    }

    document.body.classList.add('license-key-present');

    // 2022-04-28 What is this?? Seems like I tried to implement activation button already?
    var activateLicenseButtons = document.querySelectorAll('.btn-activate-license');

    for (var i = 0; i < activateLicenseButtons.length; ++i) {
        activateLicenseButtons[i].addEventListener('click', function (e) {
            e.preventDefault();

            var activatingTimeout;

            activateLicenseButtons.forEach(function (activateLicenseButton) {
                activateLicenseButton.innerText = 'Activating...';
                document.body.classList.add('license_status__in-progress');

                activatingTimeout = setTimeout(function () {
                    document.body.classList.add('license_status__error');
                    activateLicenseButton.innerText = 'Error';
                }, 5000);
            });

            if (chrome) {
                chrome.runtime.sendMessage(extensionId, { action: 'upgrade', licenseKey: licenseKey }, function (response) {
                    if (response.status === 1) {
                        clearTimeout(activatingTimeout);
                        setTimeout(function () {
                            activateLicenseButtons.forEach(function (activateLicenseButton) {
                                document.body.classList.add('license_status__in-progress-2');
                            });

                            setTimeout(function () {
                                activateLicenseButtons.forEach(function (activateLicenseButton) {
                                    document.body.classList.add('license_status__success');
                                    activateLicenseButton.innerText = 'Activated';
                                });
                            }, 2000);
                        }, 1000);
                    };
                });
            } else {
                // Not running Chrome...
                document.body.classList.add('license_status__error');
                activateLicenseButton.innerText = 'Error';
            }
        });
    }
}

var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var isEdge = navigator.userAgent.toLowerCase().indexOf('edg') > -1;

if (isFirefox) {
    document.querySelector('body').className += ' is-firefox';
}

if (isSafari) {
    document.querySelector('body').className += ' is-safari';
}

if (isEdge) {
    document.querySelector('body').className += ' is-edge';
}

/**
 * Tooltips
 */

/**
* @fileOverview
* @author Zoltan Toth
* @version 0.1
*/

/**
* @description
* Vanilla Javascript tooltip.
*
* @class
* @param {string} [options.theme=dark] - Selects one of the pre-defined tooltip styles - light or dark.
* @param {number} [options.dist=10] - Specifies the distance in pixels from trigger to tooltip.
* @param {number} [options.delay=0] - Specifies how long the tooltip remains visible after the mouse leaves the trigger.
*/

var Tooltip = function Tooltip(options) {
    var theme = options.theme || 'dark',
        delay = options.delay || 0,
        dist = options.distance || -1;

    /*
    * Attaching one mouseover and one mouseout listener to the document
    * instead of listeners for each trigger
    */
    document.body.addEventListener('mouseover', function (e) {
        var mouseoverTooltipChild = e.target.parentNode.hasAttribute('data-tooltip');

        if (!e.target.hasAttribute('data-tooltip') && !mouseoverTooltipChild) return;

        var tooltipParent = e.target;
        if (mouseoverTooltipChild) {
            tooltipParent = e.target.parentNode;
        }

        var tooltip = document.createElement('div');
        tooltip.className = 'b-tooltip ' + 'b-tooltip-' + theme;
        tooltip.innerHTML = tooltipParent.getAttribute('data-tooltip');

        document.body.appendChild(tooltip);

        var pos = tooltipParent.getAttribute('data-position') || 'center bottom',
            posHorizontal = pos.split(' ')[0];
        var posVertical = pos.split(' ')[1];

        positionAt(tooltipParent, tooltip, posHorizontal, posVertical);
    });

    document.body.addEventListener('mouseout', function (e) {

        var mouseoverTooltipChild = e.target.parentNode.hasAttribute('data-tooltip');

        if (!e.target.hasAttribute('data-tooltip') && !mouseoverTooltipChild) return;

        setTimeout(function () {
            document.body.removeChild(document.querySelector('.b-tooltip'));
        }, delay);
    });

    /**
     * Positions the tooltip.
     *
     * @param {object} parent - The trigger of the tooltip.
     * @param {object} tooltip - The tooltip itself.
     * @param {string} posHorizontal - Desired horizontal position of the tooltip relatively to the trigger (left/center/right)
     * @param {string} posVertical - Desired vertical position of the tooltip relatively to the trigger (top/center/bottom)
     *
     */
    function positionAt(parent, tooltip, posHorizontal, posVertical) {
        var parentCoords = parent.getBoundingClientRect(),
            left,
            top;

        switch (posHorizontal) {
            case 'left':
                left = parseInt(parentCoords.left) - dist - tooltip.offsetWidth;
                if (parseInt(parentCoords.left) - tooltip.offsetWidth < 0) {
                    left = dist;
                }
                break;

            case 'right':
                left = parentCoords.right + dist;
                if (parseInt(parentCoords.right) + tooltip.offsetWidth > document.documentElement.clientWidth) {
                    left = document.documentElement.clientWidth - tooltip.offsetWidth - dist;
                }
                break;

            default:
            case 'center':
                left = parseInt(parentCoords.left) + (parent.offsetWidth - tooltip.offsetWidth) / 2;
        }

        switch (posVertical) {
            case 'center':
                top = (parseInt(parentCoords.top) + parseInt(parentCoords.bottom)) / 2 - tooltip.offsetHeight / 2;
                break;

            case 'bottom':
                top = parseInt(parentCoords.bottom) + dist;
                break;

            default:
            case 'top':
                top = parseInt(parentCoords.top) - tooltip.offsetHeight - dist;
        }

        left = left < 0 ? parseInt(parentCoords.left) : left;
        top = top < 0 ? parseInt(parentCoords.bottom) + dist : top;

        tooltip.style.left = left + 'px';
        tooltip.style.top = top + pageYOffset + 'px';
    }
};

$('.btn-install').click(function (e) {
    if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Extension', 'Clicked install button', null, 36);
    }
});

$('#link--pay-monthly').click(function (e) {
    $('body').addClass('pay-monthly');

    if (typeof checkoutData !== 'undefined') {
        checkoutData.planId = 'iwr-pro-monthly';
    }

    if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Checkout', 'Switched to monthly payment option', null, 36);
    }

    e.preventDefault();
});

$('#link--pay-annually').click(function (e) {
    $('body').removeClass('pay-monthly');

    if (typeof checkoutData !== 'undefined') {
        checkoutData.planId = 'iwr-pro-48';
    }

    if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Checkout', 'Switched to annual payment option', null, 36);
    }
    e.preventDefault();
});

var tooltip = new Tooltip({
    theme: 'light', // Selects one of the pre-defined tooltip styles - light or dark.
    delay: 0 // Specifies how long the tooltip remains visible (in ms) after the mouse leaves the trigger.
});

var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
if (isFirefox) {
    document.querySelector('body').className += ' is-firefox';
}
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map
